'use strict'

const encode = require('./encode')
const d = require('./decode')

exports.encode = encode
exports.decode = d.decode
exports.decodeFromReader = d.decodeFromReader



//////////////////
// WEBPACK FOOTER
// ./~/pull-length-prefixed/src/index.js
// module id = 16
// module chunks = 0